var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      class: {
        "plans-section": true,
        mobile: _vm.isMobile(_vm.$mq)
      }
    },
    [
      !_vm.isMobile(_vm.$mq)
        ? _c("StarsBackground", { staticClass: "stars" })
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "content container gift-plans-wrapper" }, [
        _vm._m(0),
        _vm._v(" "),
        _c("div", { staticClass: "plans" }, [
          _vm.oneMonthGiftPlan && !_vm.isMobile(_vm.$mq)
            ? _c("div", { staticClass: "plan" }, [
                _c("h4", [_vm._v("1 Month")]),
                _vm._v(" "),
                _c(
                  "div",
                  [
                    _c("h5", [
                      _vm.oneMonthGiftPlan.listing_plan_price
                        ? _c("span", { staticClass: "original" }, [
                            _vm._v(
                              "\n              " +
                                _vm._s(
                                  _vm.oneMonthGiftPlan.listing_plan_price
                                    .for_display
                                ) +
                                "\n            "
                            )
                          ])
                        : _vm._e(),
                      _vm._v(
                        "\n            " +
                          _vm._s(_vm.oneMonthGiftPlan.price.for_display) +
                          "\n          "
                      )
                    ]),
                    _vm._v(" "),
                    _c(
                      "Button",
                      {
                        directives: [
                          {
                            name: "track",
                            rawName: "v-track:click",
                            value: { axId: _vm.monthAxId },
                            expression: "{ axId: monthAxId }",
                            arg: "click"
                          }
                        ],
                        staticClass: "button green-text",
                        attrs: { premium: "" },
                        on: {
                          click: function($event) {
                            return _vm.handleClick(_vm.oneMonthLocation)
                          }
                        }
                      },
                      [_vm._v("\n            Gift now\n          ")]
                    )
                  ],
                  1
                )
              ])
            : _vm.oneMonthGiftPlan
            ? _c(
                "button",
                {
                  directives: [
                    {
                      name: "track",
                      rawName: "v-track:click",
                      value: { axId: _vm.monthAxId },
                      expression: "{ axId: monthAxId }",
                      arg: "click"
                    }
                  ],
                  staticClass: "plan-button",
                  on: {
                    click: function($event) {
                      return _vm.handleClick(_vm.oneMonthLocation)
                    }
                  }
                },
                [
                  _c("b", [_vm._v("1 Month")]),
                  _vm._v(" "),
                  _c("em", [
                    _vm.oneMonthGiftPlan.listing_plan_price
                      ? _c("span", { staticClass: "original" }, [
                          _vm._v(
                            "\n            " +
                              _vm._s(
                                _vm.oneMonthGiftPlan.listing_plan_price
                                  .for_display
                              ) +
                              "\n          "
                          )
                        ])
                      : _vm._e(),
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm.oneMonthGiftPlan.price.for_display) +
                        "\n        "
                    )
                  ])
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.annualGiftPlan && !_vm.isMobile(_vm.$mq)
            ? _c("div", { staticClass: "plan popular" }, [
                _c("h4", [_vm._v("1 Year")]),
                _vm._v(" "),
                _c(
                  "div",
                  [
                    _c("h5", [
                      _vm.annualGiftPlan.listing_plan_price
                        ? _c("span", { staticClass: "original" }, [
                            _vm._v(
                              "\n              " +
                                _vm._s(
                                  _vm.annualGiftPlan.listing_plan_price
                                    .for_display
                                ) +
                                "\n            "
                            )
                          ])
                        : _vm._e(),
                      _vm._v(
                        "\n            " +
                          _vm._s(_vm.annualGiftPlan.price.for_display) +
                          "\n          "
                      )
                    ]),
                    _vm._v(" "),
                    _c(
                      "Button",
                      {
                        directives: [
                          {
                            name: "track",
                            rawName: "v-track:click",
                            value: { axId: _vm.annualAxId },
                            expression: "{ axId: annualAxId }",
                            arg: "click"
                          }
                        ],
                        staticClass: "button",
                        attrs: { green: "" },
                        on: {
                          click: function($event) {
                            return _vm.handleClick(_vm.annualLocation)
                          }
                        }
                      },
                      [_vm._v("\n            Gift now\n          ")]
                    )
                  ],
                  1
                )
              ])
            : _vm.annualGiftPlan
            ? _c(
                "button",
                {
                  directives: [
                    {
                      name: "track",
                      rawName: "v-track:click",
                      value: { axId: _vm.annualAxId },
                      expression: "{ axId: annualAxId }",
                      arg: "click"
                    }
                  ],
                  staticClass: "plan-button popular",
                  on: {
                    click: function($event) {
                      return _vm.handleClick(_vm.annualLocation)
                    }
                  }
                },
                [
                  _c("b", [_vm._v("1 Year")]),
                  _vm._v(" "),
                  _c("em", [
                    _vm.annualGiftPlan.listing_plan_price
                      ? _c("span", { staticClass: "original" }, [
                          _vm._v(
                            "\n            " +
                              _vm._s(
                                _vm.annualGiftPlan.listing_plan_price
                                  .for_display
                              ) +
                              "\n          "
                          )
                        ])
                      : _vm._e(),
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm.annualGiftPlan.price.for_display) +
                        "\n        "
                    )
                  ])
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.lifetimeGiftPlan && !_vm.isMobile(_vm.$mq)
            ? _c("div", { staticClass: "plan" }, [
                _c("h4", [_vm._v("Lifetime")]),
                _vm._v(" "),
                _c(
                  "div",
                  [
                    _c("h5", [
                      _vm.lifetimeGiftPlan.listing_plan_price
                        ? _c("span", { staticClass: "original" }, [
                            _vm._v(
                              "\n              " +
                                _vm._s(
                                  _vm.lifetimeGiftPlan.listing_plan_price
                                    .for_display
                                ) +
                                "\n            "
                            )
                          ])
                        : _vm._e(),
                      _vm._v(
                        "\n            " +
                          _vm._s(_vm.lifetimeGiftPlan.price.for_display) +
                          "\n          "
                      )
                    ]),
                    _vm._v(" "),
                    _c(
                      "Button",
                      {
                        directives: [
                          {
                            name: "track",
                            rawName: "v-track:click",
                            value: { axId: _vm.lifetimeAxId },
                            expression: "{ axId: lifetimeAxId }",
                            arg: "click"
                          }
                        ],
                        staticClass: "button green-text",
                        attrs: { premium: "" },
                        on: {
                          click: function($event) {
                            return _vm.handleClick(_vm.lifetimeLocation)
                          }
                        }
                      },
                      [_vm._v("\n            Gift now\n          ")]
                    )
                  ],
                  1
                )
              ])
            : _vm.lifetimeGiftPlan
            ? _c(
                "button",
                {
                  directives: [
                    {
                      name: "track",
                      rawName: "v-track:click",
                      value: { axId: _vm.lifetimeAxId },
                      expression: "{ axId: lifetimeAxId }",
                      arg: "click"
                    }
                  ],
                  staticClass: "plan-button",
                  on: {
                    click: function($event) {
                      return _vm.handleClick(_vm.lifetimeLocation)
                    }
                  }
                },
                [
                  _c("b", [_vm._v("Lifetime")]),
                  _vm._v(" "),
                  _c("em", [
                    _vm.lifetimeGiftPlan.listing_plan_price
                      ? _c("span", { staticClass: "original" }, [
                          _vm._v(
                            "\n            " +
                              _vm._s(
                                _vm.lifetimeGiftPlan.listing_plan_price
                                  .for_display
                              ) +
                              "\n          "
                          )
                        ])
                      : _vm._e(),
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm.lifetimeGiftPlan.price.for_display) +
                        "\n        "
                    )
                  ])
                ]
              )
            : _vm._e()
        ])
      ])
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("header", { staticClass: "header" }, [
      _c("span", { staticClass: "b-sprite-paywall-pix-gift-box2 icon" }),
      _vm._v(" "),
      _c("h1", [_vm._v("Give the gift of learning")]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "\n        Spark a lifelong love of learning. Help your loved ones nurture their curiosity and build\n        problem solving skills in a fun, bite-sized way.\n      "
        )
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }